const storage = {
    not_configured: 'Proveedor de almacenamiento no está configurado.',
    missing_parameter: 'Falta el parámetro {{parameter}} para el proveedor de almacenamiento.',
    upload_error: 'Error al cargar el archivo al proveedor de almacenamiento.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
